import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors as colorsMUI
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useState, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const OccurrenceByStatus = ({ occurrences }) => {

  const primeiro = {
    height: '325px',
    paddingTop: 5,
    textAlign: 'center',
    backgroundColor: "#fff"
  };

  const [occurrenceAmounts, setOccurrenceAmounts] = useState([]);
  const [occurrencePercentages, setOccurrencePercentages] = useState([]);

  useEffect(() => {
    updateGraph();
  }, [occurrences]); // eslint-disable-line react-hooks/exhaustive-deps

  function getQuantOccurrencesByStatus(statusNames) {
    //Cria um objeto com os nomes dos estados
    let quantOccurrencesByName = {};
    statusNames.forEach((statusName) => quantOccurrencesByName[statusName] = 0);

    occurrences.forEach((occurrence) => {
      statusNames.forEach((statusName) => {
        if (occurrence.status === statusName)
          quantOccurrencesByName[statusName]++;
      });
    });

    return quantOccurrencesByName;
  }

  function getPercentagesByStatus(quantOccurrencesByStatus, statusNames) {
    let quantOccurrencesByName = {};
    statusNames.forEach((statusName) => quantOccurrencesByName[statusName] = 0);

    const quantTotalOccurences = occurrences.length;

    Object.keys(quantOccurrencesByStatus).forEach((item) => {
      quantOccurrencesByName[item] = quantOccurrencesByStatus[item] / quantTotalOccurences * 100;
    });

    return quantOccurrencesByName;
  }

  function updateGraph() {
    const statusNames = ["Novo", "Em análise", "Resolvido", "Indeferido"];
    const colors = [colorsMUI.red[600], colorsMUI.indigo[600],
    colorsMUI.green[600], colorsMUI.grey[900]];

    let quantOccurrencesByStatus = getQuantOccurrencesByStatus(statusNames);
    let percentagesByStatus = getPercentagesByStatus(quantOccurrencesByStatus, statusNames);

    if (occurrences.length === 0) {//Se não houver ocorrências no perído escolhido
      setOccurrenceAmounts([]);
      setOccurrencePercentages({});

    } else {
      let newAmounts = [];

      statusNames.forEach((statusName, index) => {
        newAmounts.push({
          title: statusName,
          value: percentagesByStatus[statusName].toFixed(1),
          icon: ErrorIcon,
          color: colors[index]
        });
      })
      setOccurrenceAmounts(newAmounts);

      setOccurrencePercentages({
        datasets: [
          {
            data: Object.values(quantOccurrencesByStatus), //Objeto para vetor
            backgroundColor: colors,
            borderWidth: 3,
            borderColor: colorsMUI.common.white,
            hoverBorderColor: colorsMUI.common.white
          }
        ],
        labels: statusNames
      });
    }

  }

  const options = {
    animation: true,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: false
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <Card >
      <CardHeader className="box-title" title="Ocorrências por Status" />
      <Divider />

      <CardContent style={primeiro}>
        {
          Object.keys(occurrenceAmounts).length === 0 ?
            <span style={{ fontSize: "16px" }}>Não há ocorrências</span> :
            <>
              <Box
                sx={{
                  height: 200,
                  position: 'relative'
                }}
              >
                <Pie
                  data={occurrencePercentages}
                  options={options}
                />
              </Box>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: 2,
                  flexDirection: 'row',
                }}
              >
                {occurrenceAmounts.map(({
                  color,
                  icon: Icon,
                  title,
                  value
                }) => (
                  <div
                    key={title}
                    style={{
                      margin: 12,
                      textAlign: 'center',
                      width: '20%'
                    }}
                  >
                    <Icon style={{ color, fontSize: '28px' }} />
                    <Typography
                      color="textPrimary"
                      variant="body2"
                    >
                      {title}
                    </Typography>
                    <Typography
                      style={{ color }}
                      variant="h5"
                    >
                      {value}
                      %
                    </Typography>
                  </div>
                ))}
              </div>
            </>
        }

      </CardContent>
    </Card>
  );
};

export default OccurrenceByStatus;